module.exports = __webpack_public_path__ + "img/jiechu.0fe3ebd8.png";